import { useState, useEffect } from "react";
import axios from "axios";
import "react-photo-album/masonry.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { useParams } from "react-router-dom";
import { globals } from "../globals";
import ContactSheet from "./ContactSheet";

export default function GetFolderImages() {
  const [photos, setPhotos] = useState([]); // Stato per l'array photos
  const { folderName } = useParams(); // Estrae il parametro dinamico

  useEffect(() => {
    // Effettua la richiesta per ottenere gli URL, larghezza e altezza delle immagini
    axios
      .get(`${globals.homepageUrl}/php/get-images-from-db.php?folder=${folderName}`)
      .then((response) => {
        const imageObjects = response.data.map((image) => ({
          src: globals.homepageUrl+image.src,
          alt:  image.caption,
          width: image.width, // Recupera la larghezza dal backend
          height: image.height, // Recupera l'altezza dal backend
          fullwidth: image.fullwidth, // Recupera la larghezza dal backend
          fullheight: image.fullheight, // Recupera l'altezza dal backend
          description: image.caption,
          date: image.date,
          //description: image.caption + " [" + image.src.split("/").pop() + "]",
        }));
        setPhotos(imageObjects); // Aggiorna lo stato con il nuovo array photos
        //console.log("Nome del folder selezionato: " + folderName);
      })
      .catch((error) => {
        console.error("Errore durante il recupero delle immagini:", error);
      });
  }, [folderName]);


// Canonical specifico per ogni galleria
useEffect(() => {
  if (!folderName) return;

  const canonicalUrl =
    `https://www.robertomanderioli.com/gallery/${encodeURIComponent(folderName)}/`;

  let canonical = document.querySelector('link[rel="canonical"]');

  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }

  canonical.setAttribute("href", canonicalUrl);
}, [folderName]);

  //console.log("Array photos generato:", photos);

  return (
    <>
    <ContactSheet photos={photos} />
    </>
  );
}
